import { render } from "./Pixel.svg?vue&type=template&id=24ec5372"
const script = {}
script.render = render

export default script